import { FormData } from '../interface/checkoutInterface';
import { StringinterpolationOptions } from '../interface/commonInterface';

export const Path = {
  // Page Builder routes
  PAGE_BUILDER_EDIT: '/page-builder/edit',
  PAGE_BUILDER_VIEW: '/page-builder/view',
  PAGE_BUILDER_TEMPLATE_VIEW: '/page-builder/template/view',
  PAGE_BUILDER_TEMPLATE_EDIT: '/page-builder/template/edit',
  CHECKOUT: '/checkout',
};

export const eventFromType = 'Checkout Builder';

export const PageType = {
  CHECKOUT: 'checkout',
  UPSELL: 'upsell',
  CONFIRMATION: 'confirmation',
  FUNNELISH: 'funnelish',
  OTHER: 'other',
};

export const Common = {
  UNSAVED_CHANGES: 'Are you sure you want to save your changes?',
  NO_CHANGES: 'No Changes are there to save.',
  DRAFT_CHANGES: 'Are you sure you want to save your draft changes?',
};
export const PRODUCT_VARIANT_ID_PREFIX = 'gid://shopify/ProductVariant/';
export const MOCK_CREDIT_CARD_NUMBERS = [
  '4444444444444444',
  '5204240495347317',
];
export const USE_MOCK_API = 'use-mock-api';
export const PHOENIX_CART_PREVIEW = 'PHOENIX_CART_PREVIEW';

export const checkAndReturnWithProductVariantIdPrefix = (productId: string) => {
  if (productId.includes(PRODUCT_VARIANT_ID_PREFIX)) {
    return productId;
  }
  return `${PRODUCT_VARIANT_ID_PREFIX}${productId}`;
};

export const getPagePath = (query: string) => {
  return `?${query}`;
};
export const getIsEdit = () => {
  return [Path.PAGE_BUILDER_EDIT, Path.PAGE_BUILDER_TEMPLATE_EDIT].some(path =>
    window.location.pathname.includes(path),
  );
};

export const getIsView = () => {
  return [Path.PAGE_BUILDER_VIEW, Path.PAGE_BUILDER_TEMPLATE_VIEW].some(path =>
    window.location.pathname.includes(path),
  );
};

export const getIsStaging = () => {
  return process.env.REACT_APP_ENVIRONMENT?.includes('staging');
};

export const getIsTemplateEdit = () => {
  return [Path.PAGE_BUILDER_TEMPLATE_EDIT].some(path =>
    window.location.pathname.includes(path),
  );
};

export const getIsTemplateViewAndEdit = () => {
  return [
    Path.PAGE_BUILDER_TEMPLATE_EDIT,
    Path.PAGE_BUILDER_TEMPLATE_VIEW,
  ].some(path => window.location.pathname.includes(path));
};

export const getIsViewIsEdit = () => {
  return [
    Path.PAGE_BUILDER_VIEW,
    Path.PAGE_BUILDER_EDIT,
    Path.PAGE_BUILDER_TEMPLATE_VIEW,
    Path.PAGE_BUILDER_TEMPLATE_EDIT,
  ].some(path => window.location.pathname.includes(path));
};

export const defaultValues: FormData = {
  ID: '',
  ShopID: '',
  HasSubscription: false,
  terms_of_service: false,
  Items: [],
  TotalAmount: '',
  CustomerData: {
    Email: '',
    PhoneNumber: '',
  },
  SmsMarketing: {
    PhoneNumber: '',
  },
  Shipping: {
    FirstName: '',
    LastName: '',
    Address1: '',
    Address2: '',
    City: '',
    CountryCode: '',
    ProvinceCode: '',
    Zip: '',
    Organization: '',
    PhoneNumber: '',
  },
  phone_code: '',
  billing_same_as_shipping: true,
  BillingAddress: {
    FirstName: '',
    LastName: '',
    Address1: '',
    Address2: '',
    City: '',
    CountryCode: '',
    ProvinceCode: '',
    Zip: '',
    Organization: '',
    PhoneNumber: '',
  },
  ShippingMethodID: '',
};

export const initialFreeTemplateData = {
  content: [],
  root: {},
  zones: {},
};
export const urlRegExp =
  /^https?:\/\/[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;
export const emailRegExp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
export const phoneRegExp = /^\d+$/;

export const navigationPathComponents = [
  'NextButton',
  'UpsellDeal',
  'ConfirmPurchase',
  'Button',
  'ButtonSection',
];

export const defaultComponentProps = {
  header: 'Header',
  //checkout
  contactInfo: 'ContactInfo',
  shippingForm: 'ShippingForm',
  shippingMethod: 'ShippingMethod',
  preUpsell: 'PreUpsell',
  billingForm: 'BillingForm',
  payment: 'Payment',
  confirmPurchase: 'ConfirmPurchase',
  confirmPurchaseTC: 'ConfirmPurchaseTC',
  cart: 'Cart',
  orderDetails: 'OrderDetails',
  customerReviews: 'CustomerReviews',
  customerGuarantees: 'CustomerGuarantees',
  promoCode: 'PromoCode',
  termsAndSubscription: 'TermsAndSubscription',
  //post-upsells
  dealConfirmButton: 'UpsellDeal',
  nextProductButton: 'NextButton',
  declineButton: 'DeclineButton',
  productVarient: 'Product',
  timer: 'Timer',
  vip: 'Vip',
};

export const toolTipInfo = {
  SplitLayout:
    'Layout designed to split the page into two distinct sections, allowing for parallel content display.',
  StandardLayout:
    'A layout featuring a fixed header, suitable for pages requiring consistent navigation at the top.',
  Columns:
    'Component used to arrange elements in a series of vertical columns, providing a structured layout.',
  Flex: 'Component for organizing elements using a flexbox layout, offering flexible and responsive design options.',
  Grid: 'Component for organizing elements using a grid layout, offering a structured and responsive design.',
  Items:
    'Component for organizing elements using a flexbox layout, offering flexible and responsive design options.',
  VerticalSpace:
    'Component to insert vertical spacing between elements, enhancing layout clarity and readability.',
  PreDefined:
    'A component that allows users to select from predefined options, streamlining the selection process for funnelish.',
  Divider:
    'Component for adding a horizontal line, used to separate sections or elements visually.',
  Container:
    'A wrapping component for grouping elements together, often used to apply common styles or layouts.',
  Accordion:
    'Component that provides expandable sections, useful for organizing content into collapsible panels.',
  TextEditor:
    'Component that allows users to add and format text content dynamically.',
  TextField:
    'Component for capturing user input through a simple text field, often used in forms.',
  Button:
    'Component to create interactive buttons, triggering actions or events when clicked.',
  ConfirmPurchase:
    'A specialized button component for confirming purchase actions, typically used at checkout.',
  SimplePageHeader:
    'Component for adding a straightforward page header, offering clear and concise navigation or branding.',
  ContactInfo:
    'Component designed to capture and display user contact information, typically used in forms.',
  ShippingForm:
    'Form component dedicated to collecting shipping details from users during checkout.',
  BillingForm:
    'Form component for gathering billing information, ensuring secure and accurate transaction processing.',
  ShippingMethodSelect:
    'Component for selecting available shipping methods, providing users with delivery options.',
  Payment:
    'Component for selecting payment options using credit card, offering a simple user interface with billing address.',
  PaymentRadio:
    'A comprehensive form component for processing payments, supporting various payment methods and with billing address.',
  Cart: 'Component representing a shopping cart, allowing users to view and manage items they intend to purchase.',
  PromoCode:
    'Component for entering promotional codes, enabling users to apply discounts to their orders.',
  OrderDetails:
    'Component displaying detailed order information, including itemized lists and totals.',
  UpSell:
    'Component designed to promote additional products or services, encouraging higher purchase values.',
  CustomerReviews:
    'Component for showcasing customer feedback and ratings, enhancing credibility and trust.',
  Timer:
    'Component that adds a countdown timer, often used to create urgency in promotional offers.',
  TermsAndSub:
    'Component for presenting terms and subscription agreements, ensuring user awareness and consent.',
  CustomerGuarantees:
    'Component highlighting guarantees offered to customers, building confidence in purchases.',
  VipComponent:
    'A specialized section for VIP users, offering exclusive content or features.',
  GeneralTerms:
    'Component that opens a new section , providing additional information.',
  ImageUploader:
    'Component that allows users to upload and manage images, often used in profiles or product listings.',
  AlwaysVip:
    'Section dedicated to VIP features, providing continuous access to premium content or services.',
  SavingCalculator:
    'Component for calculating potential savings, helping users make informed financial decisions.',
  // Styles props
  backgroundColor:
    'Choose the background color for this section to set the overall look and feel.',
  headBgColor: 'Choose the background color for the header section.',
  bgColorLeft: 'Choose the background color for the left column.',
  'Error Color':
    'Choose the color of the text for the form and other error messages.',
  'Theme Color':
    'Choose the color of the entire theme to maintain a consistent look and feel.',
  bgColorRight: 'Choose the background color for the right column.',
  hoverColor:
    'Select a color that appears when users hover over this section for a dynamic effect.',
  textColor:
    'Pick the color of the text in this section to ensure readability and style.',
  fontSize: 'Adjust the size of the text for better visibility and emphasis.',
  'Custom CSS':
    'Add custom CSS by manually through code editor or inject as many as stylesheets through link.',
  'Custom Scripts':
    'Add custom scripts to enhance the functionality of this checkout by manually through code editor or inject as many as scripts through link.',
  fontWeight: 'Set the thickness of the text to make it stand out or blend in.',
  lineHeight:
    'Adjust the line spacing between lines to set the value in decimal or number and control the gap between lines',
  desktopMargin:
    'Define the space around this section on desktop screens for layout control.',
  tabletMargin:
    'Specify the margin for this section on tablet devices for a responsive design.',
  mobileMargin:
    'Set the space around this section on mobile devices for optimal viewing.',
  desktopPadding:
    'Add padding inside this section on desktop screens to create space around content.',
  tabletPadding:
    'Specify padding for this section on tablet devices for a balanced layout.',
  mobilePadding:
    'Set the padding inside this section on mobile devices to enhance readability.',
  'Background Image':
    'Select an image from the media library to customize the visual appearance of background for this section.',
  Image:
    'Select an image from the media library or enter a url to display the image.',
  'Header Text':
    'This is the main title or heading displayed at the top of a section or page. It should convey the primary message or topic to the user.',
  Height: 'The height property controls the height of the input field.',
  Width:
    'This is the horizontal dimension of a UI element. Setting the width allows you to control how much space an element occupies on the page.',
  'Justify-Content':
    'This property is used to align items within a container along the main axis. It can distribute space evenly or position items at the start, center, or end.',
  'Show Divider Line For Total':
    'This property will show the divider line for the total amount in the cart.',
  'align-items':
    'This property aligns items within a container along the cross-axis. It ensures consistent alignment of elements, such as centering them vertically.',
  'Border Radius':
    'This property rounds the corners of a UI element. It can be used to soften the appearance of elements, making them more visually appealing.',
  'Input Border radius':
    'Adjust the border radius to change the roundness of the input field corners.',
  'Row Gap':
    'This property defines the space between each row in a form. It allows for customization and visual distinction.',
  'Column Gap':
    'This property defines the space between each column in a form. It allows for customization and visual distinction.',
  'Checkbox Color': 'This property sets the color of the checkbox in the form.',
  'Vertical Align':
    'This property aligns the content of a container vertically. It ensures consistent alignment of elements, such as centering them vertically.',
  'Icon Color': 'This property sets the color of the icon in the form.',
  'Default Expanded':
    'This property sets the default state of the accordion, either open or closed.',
  'Border Color':
    'This property sets the color of the border around the element, allowing for customization and visual distinction.',
  Shadow:
    'This property adds a shadow effect to the element, creating depth and separation.',
  'Show Dropdown':
    'This property will show the dropdown for the shipping method.',
  'Show Dropdown Arrow': 'This property will show the dropdown Arrow.',
  'Selected Checkbox color':
    'This property sets the color of the selected checkbox in the form.',
  'Show Name on card':
    'This property will show the name on the card in the payment section.',
  'Hide News Letter':
    'This property will hide the newsletter in the contact information section.',
  'Show flashing arrow':
    'This property will show the flashing arrow in the upsell deal component.',
  Color:
    'This property will define the color of the flashing arrow in the upsell deal component.',
  Speed:
    'This property will define the speed of the flashing arrow in the upsell deal component.',
  'Show Image':
    'This property will show the image in the upsell deal component.',
  'Position Sticky':
    'This property will define the position of the header whether it is sticky or not.',
  'Column Height':
    'This property sets the height of the column in the flex layout.',
  'Number of columns':
    'This property sets the number of columns in the flex layout by default two.',
  Wrap: 'This property defines whether the flex items are forced onto one line or can wrap onto multiple lines.',
  'Grid Columns':
    'This property sets the number of columns in the grid layout.',
  'Order Summary Cart Total Color':
    'This property sets the color of the cart total in the order summary section.',
  'Star option':
    'This property will define the star color option in the customer reviews section.',
  'Place Holder':
    'This is the text shown inside an input field before the user enters any data. It provides a hint or example of the expected input.',
  'Order Summary Text':
    "This is the text displayed in the order summary section in mobile and tablet devices, providing a clear overview of the user's purchase details.",
  'Mobile Summary Cart Total':
    'Enabling this will show the total amount of the cart in the mobile and tablet summary section.',
  Border:
    'This property adds a border around the element, creating a visual separation from other elements or sections.',
  borderColor:
    'This property sets the color of the border around the element, allowing for customization and visual distinction.',
  'Text Color':
    'This property sets the color of the text through out the element, allowing for customization and visual distinction.',
  Distribution:
    'This property defines how much space should be distributed between each column in a Columns component. If the layout is automatic, each column will take an equal amount of space.',
  Gap: 'This property defines the space between each child element inside flex or columns layout.',
  Direction:
    'This property defines the direction of the flex or columns layout, such as reverse or straight.',
  direction:
    'This property defines the alignment of the divider, either horizontally or vertically.',
  'Minimum Item Width/Height':
    'This property sets the minimum width and height of the item in the flex layout.',
  size: 'This property sets the size of the vertical space between elements.',
  position:
    'Position: Defines how an element is positioned on the page. Sticky: Keeps the element fixed in place within its container as you scroll, but only within the container’s boundaries.',
  'Border Width':
    'This property sets the width of the border around the element.',
  'Border Style':
    'This property sets the style of the border around the element, such as solid, dashed, or dotted.',
  'Text align':
    'This property aligns the text within the element, such as left, right, center, or justify.',
  'Justify Content':
    'This property aligns the content of a container along the main axis. It can distribute space evenly or position items at the start, center, or end.',
  'Flex Direction':
    'This property defines the direction of the flex layout, such as row, row-reverse, column, or column-reverse.',
  Arrow: 'This property will define the arrow in the upsell deal component.',
  'corousel Interval':
    'This property controls the scrolling interval of the carousel, setting the speed at which reviews move. It helps create a smooth and engaging visual experience',
  'Accordion Open Text':
    'This is the text displayed when the accordion is open.',
  'Accordion Close Text':
    'This is the text displayed when the accordion is closed.',
  'Show Grand Total':
    'This property will show the grand total of the cart in the drop down header.',
  Name: 'This property will define the name of the button.',
  QuillEditor:
    'This editor allows you to format text with bold, italics, and underline. Easily insert images, links, and bullet lists.',
  'Next Page':
    'This property will define the next page to navigate to when the user clicks the button.',
  'Show Header': 'This toggle will show or hide the header of the component.',
  Show: 'Through this toggle, you can select which components to show on the right side of the header.',
  'Logo Align':
    'This property will define the alignment of the logo in the header whethere left or center.',
  Absolute:
    'This property will define the position of the header whether it is absolute or relative.',
  'Sub Text':
    'This property will define the text of the header for the payment.',
  'Show Billing Address':
    'Through this toggle, you can select whether to show the billing address or not.',
  'Show Sub Text': ' This toggle to choose whether to display the subtext.',
  Title:
    'This property will define the title of the VIP component which will be displayed on the top of the component.',
  Description:
    'This property will define the description of the VIP component which will be displayed below the title.',
  'Benefits Title':
    'This property will define the title of the benefits of the VIP component.',
  'Benefits Description':
    'This property will define the description of the benefits of the VIP component.',
  Interval:
    'This property will define the timer to be shown to the user in seconds.',
  'Sale Text':
    'This property will define the text to be shown in sale text header.',
  'Sale Text Color': 'This property will define the color of the sale text.',
  'Body Text Color': 'This property will define the color of the body text.',
  'Body Text':
    'This property will define the text to be shown in the body of the timer component.',
  'Font Family':
    'This property specifies the typeface used for text content in a UI element. It affects the overall look and readability of the text.',
  CustomPixel:
    'Add custom pixel code to track user behavior or target specific audiences.',
  'Divider Line':
    'Insert a horizontal line horizontally centered within the header section.',
  'Hide Verified Buyer':
    'Hide the verified buyer in the customer reviews section.',
  'Star Rating Position':
    'This property will define the position of the star rating in the customer reviews section.',
  'Hide Image': 'Hide the image in the customer reviews section.',
  'Next Button':
    'Through this button, we can select the next page the user needs to navigate.',
  Text: 'This property will define the main text for this particular component to show.',
  'Upsell Deal':
    'This property will define the deal for the upsell product component.',
  Product:
    'This property will show the products that are configured for the post upsell.',
  ReturnButton:
    'This property will define the return button to navigate back to the store.',
  device:
    'Customize the layout for different devices, such as desktop, tablet, and mobile, to ensure optimal user experience.',
  'Divider Bottom Of Container':
    'Enabling this option makes the divider line stay at the bottom of the layout. Disabling it allows the divider line to adjust based on the height of the components',
  user: 'This property will define the user details',
  'Border Summary': 'Enabling the border for the order summary.',
  OrderSummary:
    'This property will define the order summary text to be shown in the order summary section.',

  opentext: 'This property will define the open text for the accordion.',
  closetext: 'This property will define the close text for the accordion.',
  footer: 'This property will define the link for the footer.',
  PostUpsellOrderSummary:
    'This property will define the order summary text to be shown in the post upsell order summary section.',
  'Max Width':
    "This property will define the maximum width of the component's content.",
  'Background Repeat':
    'This property will define the background repeat of the component.',
  'Background Position':
    'This property will define the background position of the component.',
  'Background Size':
    'This property will define the background size of the component.',
  'Selected radio color':
    'This property will define the selected radio color of the component.',
  textAlign:
    'Align the text to the left, right, center, or justify for a polished look.',
  Footer: 'This property will define the footer text for the component.',
  Favicon: 'This property will define the favicon of the page.',
  PageTitle: 'This property will define the title of the page.',
  Variants: 'This property will define the variants of the product.',
  Products:
    'This property will define the product price to be shown in the component.',
  EnrollementStyle:
    'This property will define the enrollement style of the component.',
  'Is Checkbox auto Selected':
    ' This property will define the checkbox to be auto selected.',
  productRemove:
    'This property will define the color of the product remove icon.',
  price: 'This property will define the color of the product price.',
  'Side-By-Side Exp & CVV (Mobile)':
    'This property will define the new layout for the exp and cvv fields in the payment section only for mobile.',
  quantityDecreaseIcon:
    'This property will define the color of the product decrease icon.',
  quantityIncreaseIcon:
    'This property will define the color of the product increase icon.',
  quantityDecreaseButton:
    'This property will define the color of the product decrease button.',
  quantityIncreaseButton:
    'This property will define the color of the product increase button.',
  'Product Price Position':
    'This property will define the position of the product price.',
  PhoneNumber: 'This property will define the phone number of the user.',
  TextBanner: 'This property will define the text banner of the component.',
  'Social Media Icon':
    'This property will define the social media icon to be shown in the component.',
  'Checkbox Shape': 'This property sets the shape of the checkbox in the form.',
  'Flow Direction':
    'This property will define the flow direction of the component.',
  'Speed (in sec)':
    'This property will define the speed of the scrolling text in text banner component.',
  hours:
    'This property will define the label of the hours in the timer component.',
  minutes:
    'This property will define the label of the minutes in the timer component.',
  seconds:
    'This property will define the label of the seconds in the timer component.',
  'Show Free for Zero':
    'This property will define whether to show the free for zero in the upsell deal component.',
  milliseconds:
    'This property will define the label of the milliseconds in the timer component.',
  'Include Hours in Countdown':
    'This property will define whether to include hours in the countdown timer.',
  'Include Milliseconds in Countdown':
    'This property will define whether to include milliseconds in the countdown timer.',
  ApplePayButton:
    'This component is used to display the Apple Pay button in the payment section.',
  GooglePayButton:
    'This component is used to display the Google Pay button in the payment section.',
  placeholder: 'This property will define the text for the placeholder',
  DefaultCountry:
    'This property will define the default value for the country code',
  DefaultPhoneCode:
    'This property will define the default value for the phone code',
  'Start rate':
    'This property will define the start rate of the customer reviews section.',
  'Hide Rating':
    'This property will define whether to hide the rating in the customer reviews section.',
  showOnlyCountry:
    'This property will define whether to show only the country selected.',
  'Show Product Description':
    'This property will define whether to show the product description in the component.',
  showOnlyStates:
    'This property will define whether to show only the states/provinces selected.',
  'Allow Horizontal Scroll':
    'This property will define whether to allow horizontal scrolling in the component.',
  'Show Quantity Buttons':
    'This property will define whether to show the quantity buttons in the component.',
  savingsIconColor:
    'This property will define the color of the toggle text in the component.',
  'Button Alignment':
    'This property will define  the alignment of the button in the component.',
  'Carousel Panel':
    'This property will define the carousel panel of the component.',
  'First and Last Name':
    'This property will define the first and last name of the shipping form.',
  'Grid Layout': 'This property will define the grid layout of the component.',
  'Hide Price':
    'This property will define whether to hide the price in the component.',
  'Hide Product Image':
    'This property will define whether to show the product image in the component.',
  'Hide Remove Button':
    'This property will define whether to show the remove button in the component.',
  'Descreiption Position':
    'This property will define the position of the description in the component.',
  'Hide Rating Value':
    'This property will define whether to hide the rating value in the customer reviews section.',
  'Star Rating':
    'This property will define the star rating of the customer reviews section.',
  ProductVariantSelection:
    'This property will define the product variant selection of the component.',
  arrowColor:
    'This property will define the color of the arrow in the product variant selection component.',
  arrowSize:
    'This property will define the size of the arrow in the product variant selection component.',
  FAQDisclosureSection:
    'This property will define the FAQ disclosure section of the component.',
  DividerThickness:
    'This property will define the thickness of the divider in the component.',
  DividerStyle:
    'This property will define the style of the divider in the component.',
  iconSize:
    'This property will define the size of the dropdown icon in the component.',
  iconColor:
    'This property will define the color of the dropdown icon in the component.',
  showDivider:
    'This property will define whether to show the divider in the component.',
  dividerColor:
    'This property will define the color of the divider in the component.',
  dividerThickness:
    'This property will define the thickness of the divider in the component.',
  dividerStyle:
    'This property will define the style of the divider in the component.',
  'Default Collapse':
    ' This property will define the default collapse of the accordion.',
  titleBackgroundColor:
    'This property will define the background color of the title in the accordion.',
  descriptionBackgroundColor:
    'This property will define the background color of the description in the accordion.',
  'Star Option': 'show the star option in the customer reviews section.',
  'Hide Star Rating':
    'This property will define whether to hide the star rating in the customer reviews section.',
  'Content Position':
    'This property will define the content position of the component.',
  'Scroll Control':
    'This property will define the scroll control of the component.',
  Quantity: 'This property will define the quantity of the product.',
  'Hide Offer Amount':
    'This property will define whether to hide the offer amount in the upsell deal component.',
  'Button Position':
    'This property will define the position of the button in the component.',
  'Hide Button':
    'This property will define whether to hide the button in the component.',
  'Hide GrandTotal':
    'This property will define whether to hide the grand total in the component.',
  'Hide SubTotal':
    'This property will define whether to hide the sub total in the component.',
  'SubTotal Text':
    'This property will define the text for the sub total in the component.',
  'Grand Total Text':
    'This property will define the text for the grand total in the component.',
  'Card Position':
    'This property will define the position of the card in the component.',
  'Stay on Page After Adding to Cart':
    'This property will define whether to stay on the page after adding the product to the cart.',
  'Gift Product Timer': 'This component will define the gift product timer.',
  'Show Upon Shipping Form Completion':
    'This property will define whether to show the component upon completion of the shipping form is validated.',
  'Text Dropdown':
    'This property will define the text dropdown of the component.',
  'Show Header Image':
    'This property will define whether to show the header image in the component.',
  'Google Map Pin':
    'This will display a Google Map centered on the address. The location is automatically pulled from the Shopify order. A Google Maps API key is required. ',
  'Zoom Level':
    'This property will control how close the map is zoomed in. Higher = closer.',
  'Checkbox Border Color':
    'This property will define the border color of the checkbox in the component.',
  'Hover Tooltip':
    'This component will display a hover tooltip of the component.',
  'Tooltip Text Align':
    'This property will define the text alignment of the tooltip in the component.',
  'Tooltip Background Color':
    'This property will define the background color of the tooltip in the component.',
  'Tooltip Icon Color':
    'This property will define the color of the icon in the tooltip.',
  'Icon Size': 'This property will define the size of the icon in the tooltip.',
  'Show Arrow':
    'This property will define whether to show the arrow in the tooltip.',
  'Show Header Text':
    'This property will define whether to show the header text in the component.',
  'Show Description Text':
    'This property will define whether to show the description text in the component.',
  'Toggle Size':
    'This property will define the size of the toggle in the component.',
  'Checked Border Color':
    'This property will define the border color of the checkbox when it is checked.',
  'Unchecked Border Color':
    'This property will define the border color of the checkbox when it is unchecked.',
  'Checkbox Size':
    'This property will define the size of the checkbox in the component.',
  'Check Mark Color':
    'This property will define the color of the check mark in the component.',
  'Checked Toggle Color':
    'This property will define the color of the toggle when it is checked.',
  'Unchecked Toggle Color':
    'This property will define the color of the toggle when it is unchecked.',
  'Check Mark Size':
    'This property will define the size of the check mark in the component.',
  'Required For Payment':
    'This property will define whether the field is required for payment processing.',
  'Hide Colons in Countdown':
    'This property will define whether to hide colons in the countdown timer.',
  'SMS Consent':
    'This component is responsible for managing SMS marketing options.',
  'Email Consent':
    'This component is responsible for managing Email marketing options.',
  'SMS And Email Consent':
    'This component is responsible for managing SMS and Email marketing options.',
  'Carousel Image':
    'This property will define the image to be shown in the carousel component.',
  'Auto Scroll':
    'This property will define whether the carousel should auto-scroll.',
  'Hide Arrows':
    'This property will define whether to hide the arrows in the carousel component.',
  'Transition Time':
    'This property will define the transition time for the carousel component.',
  'Thumbnail Gap':
    'This property will define the gap between thumbnails in the carousel component.',
  'Hide Thumbnails':
    'This property will define whether to hide the thumbnails in the carousel component.',
  Pulse_Animation:
    'This property will define whether the pulse animation is enabled for the component.',
  PayPalButton:
    'This component is used to display the PayPal button in the payment section.',
  'Z-Index':
    'This property will define the z-index of the component to control its stacking order on the page.',
  'backgroundColor(Before Input)':
    'Choose the background color for this section before input.',
  'backgroundColor(After Input)':
    'Choose the background color for this section after input.',
  '2xlMargin': 'This property will define the margin for the xl screen size.',
  '3xlMargin': 'This property will define the margin for the 2xl screen size.',
  'gradiant-type': 'This propery will define the type of the gradient color',
  'Lazy Loader': 'If enabled, Images load after the page load.',
  'Fetch Priority':
    'If enabled, images load with high priority, helping them appear faster.',
  'Async Loader': 'If enabled, Scripts load after the page load.',
  'Lazy Loading':
    'If enabled, images load after the page load, except the first image which loads immediately.',
  'Background Color':
    'Choose the background color for this section to set the overall look and feel.',
  'Tag Position':
    'This property will define the position of the tag in the component.',
  Defer:
    'If enabled, Loads scripts faster in the background and runs them after the page loads.',
  VideoPlayer:
    'This component is used to display a video player in the component.',
  TicketsEntryMultiplier:
    'This property will define the monthly multiplier for the VIP component.',
  CustomHTML:
    'This component allows you to add custom HTML code to your page for enhanced customization and functionality.',
};

export const mandatoryComponents: { [key: string]: string[] } = {
  checkout: [
    // defaultComponentProps.header,
    defaultComponentProps.contactInfo,
    defaultComponentProps.shippingForm,
    // defaultComponentProps.billingForm,
    defaultComponentProps.payment,
    defaultComponentProps.confirmPurchase,
    defaultComponentProps.cart,
    defaultComponentProps.orderDetails,
    // defaultComponentProps.customerReviews,
    // defaultComponentProps.customerGuarantees,
  ],
  upsell: [
    // defaultComponentProps.header,
    // defaultComponentProps.timer,
    defaultComponentProps.declineButton,
    // defaultComponentProps.productVarient,
    // defaultComponentProps.dealConfirmButton,
    // defaultComponentProps.nextProductButton,
  ],
  confirmation: ['TextField', 'TextEditor', 'Divider'],
};

export const highlightingComponents = {
  Text: ['TextField', 'TextEditor'],
  Blocks: ['VerticalSpace', 'Divider'],
  'Form Components': [
    defaultComponentProps.contactInfo,
    defaultComponentProps.shippingForm,
    defaultComponentProps.billingForm,
    defaultComponentProps.payment,
  ],
  'Checkout Components': [
    defaultComponentProps.cart,
    defaultComponentProps.orderDetails,
  ],
  Buttons: [defaultComponentProps.confirmPurchase],
  Header: ['Header'],
  'Post Upsell': [
    defaultComponentProps.timer,
    defaultComponentProps.productVarient,
    defaultComponentProps.dealConfirmButton,
    defaultComponentProps.nextProductButton,
  ],
};

export const options: StringinterpolationOptions[] = [
  {
    label: 'Total savings',
    key: 'total_savings',
    value: 'cart.cartData',
    showInTemplates: [PageType.CHECKOUT, PageType.CONFIRMATION],
  },

  {
    label: 'Email',
    key: 'email',
    value: 'cart.cartData.Email',
    showInTemplates: [PageType.CONFIRMATION, PageType.UPSELL],
  },
  {
    label: 'Phone',
    key: 'phone',
    value: 'cart.cartData.PhoneNumber',
    showInTemplates: [PageType.UPSELL],
  },
  {
    label: 'Total Entries',
    key: 'total_entries',
    value: 'cart.cartData.TicketEntries.totalEntries',
    showInTemplates: [PageType.CHECKOUT],
  },
  {
    label: 'Product Entries Multiplier',
    key: 'product_entries_multiplier',
    value: 'cart.cartData.TicketEntries.productEntriesMultiplier',
    showInTemplates: [PageType.CHECKOUT],
  },
  {
    label: 'First Name',
    key: 'first_name',
    value: 'cart.cartData.ShippingAddress.FirstName',
    showInTemplates: [PageType.CONFIRMATION, PageType.UPSELL],
  },
  {
    label: 'Last Name',
    key: 'last_name',
    value: 'cart.cartData.ShippingAddress.LastName',
    showInTemplates: [PageType.CONFIRMATION, PageType.UPSELL],
  },
  {
    label: 'Shipping Address1',
    key: 'shipping_address1',
    value: 'cart.cartData.ShippingAddress.Address1',
    showInTemplates: [PageType.CONFIRMATION, PageType.UPSELL],
  },
  {
    label: 'Shipping Address2',
    key: 'shipping_address2',
    value: 'cart.cartData.ShippingAddress.Address2',
    showInTemplates: [PageType.CONFIRMATION, PageType.UPSELL],
  },
  {
    label: 'Shipping City',
    key: 'shipping_city',
    value: 'cart.cartData.ShippingAddress.City',
    showInTemplates: [PageType.CONFIRMATION, PageType.UPSELL],
  },
  {
    label: 'Shipping State',
    key: 'shipping_state',
    value: 'cart.cartData.ShippingAddress.ProvinceCode',
    showInTemplates: [PageType.CONFIRMATION, PageType.UPSELL],
  },
  {
    label: 'Shipping Zip',
    key: 'shipping_zip',
    value: 'cart.cartData.ShippingAddress.Zip',
    showInTemplates: [PageType.CONFIRMATION, PageType.UPSELL],
  },
  {
    label: 'Shipping Country',
    key: 'shipping_country',
    value: 'cart.cartData.ShippingAddress.CountryCode',
    showInTemplates: [PageType.CONFIRMATION, PageType.UPSELL],
  },
  {
    label: 'Products Orders',
    key: 'products_orders',
    value: 'orderDetails',
    showInTemplates: [PageType.CONFIRMATION],
  },
  {
    label: 'Products Orders Price',
    key: 'products_orders_price',
    value: 'orderDetails',
    showInTemplates: [PageType.CONFIRMATION],
  },
  {
    label: 'First Name Billing',
    key: 'first_name_billing',
    value: 'cart.cartData.BillingAddress.FirstName',
    showInTemplates: [PageType.CONFIRMATION],
  },
  {
    label: 'Last Name Billing',
    key: 'last_name_billing',
    value: 'cart.cartData.BillingAddress.LastName',
    showInTemplates: [PageType.CONFIRMATION],
  },
  {
    label: 'Billing Address1',
    key: 'billing_address1',
    value: 'cart.cartData.BillingAddress.Address1',
    showInTemplates: [PageType.CONFIRMATION],
  },
  {
    label: 'Billing Address2',
    key: 'billing_address2',
    value: 'cart.cartData.BillingAddress.Address2',
    showInTemplates: [PageType.CONFIRMATION],
  },
  {
    label: 'Billing City',
    key: 'billing_city',
    value: 'cart.cartData.BillingAddress.City',
    showInTemplates: [PageType.CONFIRMATION],
  },
  {
    label: 'Billing State',
    key: 'billing_state',
    value: 'cart.cartData.BillingAddress.ProvinceCode',
    showInTemplates: [PageType.CONFIRMATION],
  },
  {
    label: 'Billing Zip',
    key: 'billing_zip',
    value: 'cart.cartData.BillingAddress.Zip',
    showInTemplates: [PageType.CONFIRMATION],
  },
  {
    label: 'Billing Country',
    key: 'billing_country',
    value: 'cart.cartData.BillingAddress.CountryCode',
    showInTemplates: [PageType.CONFIRMATION],
  },
  {
    label: 'Shipping Method',
    key: 'shipping_method',
    value: 'checkout.availableShippingMethods',
    showInTemplates: [PageType.CONFIRMATION],
  },
  {
    label: 'Vip Login Email Address',
    key: 'vip_login_email_address',
    value: 'store.storeData.VipLoginEmailAddress',
  },
  {
    label: 'Domain URL',
    key: 'domain_URl',
    value: 'store.storeData.DomainURL',
  },
  {
    label: 'Store URL',
    key: 'store_URl',
    value: 'store.storeData.ShopURL',
  },
  {
    label: 'Store Phone',
    key: 'store_phone',
    value: 'store.storeData.CustomerServiceNumber',
  },
  {
    label: 'Store Email',
    key: 'store_email',
    value: 'store.storeData.CustomerServiceEmail',
  },
  {
    label: 'Visitor City',
    key: 'visitor_city',
    value: 'ip.city',
    showInTemplates: [PageType.CHECKOUT],
  },
  {
    label: 'Visitor State',
    key: 'visitor_state',
    value: 'ip.state',
    showInTemplates: [PageType.CHECKOUT],
  },
  {
    label: 'Visitor Country ',
    key: 'visitor_country',
    value: 'ip.country',
    showInTemplates: [PageType.CHECKOUT],
  },
  {
    label: 'Upsell Product Name',
    key: 'upsell_product_name',
    value: 'postUpSell.currentUpsellData.products[0].assignedProducts.label',
    showInTemplates: [PageType.UPSELL],
  },
  {
    label: 'Upsell Product Price',
    key: 'upsell_product_price',
    value:
      'postUpSell.currentUpsellData.products[0].variants[0].productVariants.productPrice',
    showInTemplates: [PageType.UPSELL],
  },
  {
    label: 'Upsell Product Original Price',
    key: 'upsell_product_original_price',
    value: 'postUpSellState.selectedVariant.OriginalPrice',
    showInTemplates: [PageType.UPSELL],
  },
  {
    label: 'Total Quantity in Cart',
    key: 'total_quantity_in_cart',
    value: 'cart.cartData.LineItems',
    showInTemplates: [PageType.CHECKOUT],
  },
  {
    label: 'Grand Total',
    key: 'grand_total',
    value: 'cart.cartData.TotalAmount',
    showInTemplates: [PageType.CHECKOUT, PageType.UPSELL],
  },
  {
    label: 'Sub Total',
    key: 'sub_total',
    value: 'cart.cartData.SubtotalAmount',
    showInTemplates: [PageType.CHECKOUT],
  },
  {
    label: 'Currency Code',
    key: 'currency_code',
    value: 'cart.cartData.currencyCode',
  },
  {
    label: 'Currency Code Symbol',
    key: 'currency_code_symbol',
    value: 'cart.cartData.currencyCode',
  },
  {
    label: 'Post upsell Quantity',
    key: 'post_upsell_quantity',
    value: 'postUpSellState.selectedVariant.Quantity',
    showInTemplates: [PageType.UPSELL],
  },
  {
    label: 'Host Name',
    key: 'hostname',
    value: '',
    showInTemplates: [PageType.UPSELL],
  },
  {
    label: 'Path',
    key: 'path',
    value: '',
    showInTemplates: [PageType.UPSELL],
  },
  // for future use
  // {
  //   label: 'Upsell Product Image',
  //   key: 'UpsellProductImage',
  //   value: 'postUpSellState.selectedVariant.ImageURL',
  // },
  // {
  //   label: 'Order Number',
  //   key: 'OrderNumber',
  //   value: 'store.checkout.checkoutOrderID',
  //   showInTemplates: [PageType.CONFIRMATION],
  // },
];

export const JustifyOptions = [
  { label: 'center', value: 'justify-center' },
  { label: 'start', value: 'justify-start' },
  { label: 'end', value: 'justify-end' },
  { label: 'between', value: 'justify-between' },
  { label: 'around', value: 'justify-around' },
  { label: 'evenly', value: 'justify-evenly' },
];

export const StartrateOptions = [
  { label: '0', value: '0' },
  { label: '0.5', value: '0.5' },
  { label: '1', value: '1' },
  { label: '1.5', value: '1.5' },
  { label: '2', value: '2' },
  { label: '2.5', value: '2.5' },
  { label: '3', value: '3' },
  { label: '3.5', value: '3.5' },
  { label: '4', value: '4' },
  { label: '4.5', value: '4.5' },
  { label: '5', value: '5' },
];

export const GapOptions = [
  { label: '0', value: 'gap-0' },
  { label: '1', value: 'gap-1' },
  { label: '2', value: 'gap-2' },
  { label: '4', value: 'gap-4' },
  { label: '8', value: 'gap-8' },
  { label: '16', value: 'gap-16' },
];

export const deviceOptions = [
  { label: 'Desktop', value: 'desktop', deviceType: 'desktop' },
  { label: 'Tablet', value: 'tablet', deviceType: 'tablet' },
  { label: 'Mobile', value: 'mobile', deviceType: 'mobile' },
];

export const countryCurrencyList = [
  {
    countryCode: 'AD',
    countryName: 'Andorra',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'AE',
    countryName: 'United Arab Emirates',
    currencyCode: 'AED',
  },
  {
    countryCode: 'AF',
    countryName: 'Afghanistan',
    currencyCode: 'AFN',
  },
  {
    countryCode: 'AG',
    countryName: 'Antigua and Barbuda',
    currencyCode: 'XCD',
  },
  {
    countryCode: 'AI',
    countryName: 'Anguilla',
    currencyCode: 'XCD',
  },
  {
    countryCode: 'AL',
    countryName: 'Albania',
    currencyCode: 'ALL',
  },
  {
    countryCode: 'AM',
    countryName: 'Armenia',
    currencyCode: 'AMD',
  },
  {
    countryCode: 'AO',
    countryName: 'Angola',
    currencyCode: 'AOA',
  },
  {
    countryCode: 'AQ',
    countryName: 'Antarctica',
    currencyCode: '',
  },
  {
    countryCode: 'AR',
    countryName: 'Argentina',
    currencyCode: 'ARS',
  },
  {
    countryCode: 'AS',
    countryName: 'American Samoa',
    currencyCode: 'USD',
  },
  {
    countryCode: 'AT',
    countryName: 'Austria',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'AU',
    countryName: 'Australia',
    currencyCode: 'AUD',
  },
  {
    countryCode: 'AW',
    countryName: 'Aruba',
    currencyCode: 'AWG',
  },
  {
    countryCode: 'AX',
    countryName: 'Åland Islands',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'AZ',
    countryName: 'Azerbaijan',
    currencyCode: 'AZN',
  },
  {
    countryCode: 'BA',
    countryName: 'Bosnia and Herzegovina',
    currencyCode: 'BAM',
  },
  {
    countryCode: 'BB',
    countryName: 'Barbados',
    currencyCode: 'BBD',
  },
  {
    countryCode: 'BD',
    countryName: 'Bangladesh',
    currencyCode: 'BDT',
  },
  {
    countryCode: 'BE',
    countryName: 'Belgium',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'BF',
    countryName: 'Burkina Faso',
    currencyCode: 'XOF',
  },
  {
    countryCode: 'BG',
    countryName: 'Bulgaria',
    currencyCode: 'BGN',
  },
  {
    countryCode: 'BH',
    countryName: 'Bahrain',
    currencyCode: 'BHD',
  },
  {
    countryCode: 'BI',
    countryName: 'Burundi',
    currencyCode: 'BIF',
  },
  {
    countryCode: 'BJ',
    countryName: 'Benin',
    currencyCode: 'XOF',
  },
  {
    countryCode: 'BL',
    countryName: 'Saint Barthélemy',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'BM',
    countryName: 'Bermuda',
    currencyCode: 'BMD',
  },
  {
    countryCode: 'BN',
    countryName: 'Brunei',
    currencyCode: 'BND',
  },
  {
    countryCode: 'BO',
    countryName: 'Bolivia',
    currencyCode: 'BOB',
  },
  {
    countryCode: 'BQ',
    countryName: 'Caribbean Netherlands',
    currencyCode: 'USD',
  },
  {
    countryCode: 'BR',
    countryName: 'Brazil',
    currencyCode: 'BRL',
  },
  {
    countryCode: 'BS',
    countryName: 'Bahamas',
    currencyCode: 'BSD',
  },
  {
    countryCode: 'BT',
    countryName: 'Bhutan',
    currencyCode: 'BTN',
  },
  {
    countryCode: 'BV',
    countryName: 'Bouvet Island',
    currencyCode: 'NOK',
  },
  {
    countryCode: 'BW',
    countryName: 'Botswana',
    currencyCode: 'BWP',
  },
  {
    countryCode: 'BY',
    countryName: 'Belarus',
    currencyCode: 'BYR',
  },
  {
    countryCode: 'BZ',
    countryName: 'Belize',
    currencyCode: 'BZD',
  },
  {
    countryCode: 'CA',
    countryName: 'Canada',
    currencyCode: 'CAD',
  },
  {
    countryCode: 'CC',
    countryName: 'Cocos (Keeling) Islands',
    currencyCode: 'AUD',
  },
  {
    countryCode: 'CD',
    countryName: 'Democratic Republic of the Congo',
    currencyCode: 'CDF',
  },
  {
    countryCode: 'CF',
    countryName: 'Central African Republic',
    currencyCode: 'XAF',
  },
  {
    countryCode: 'CG',
    countryName: 'Republic of the Congo',
    currencyCode: 'XAF',
  },
  {
    countryCode: 'CH',
    countryName: 'Switzerland',
    currencyCode: 'CHF',
  },
  {
    countryCode: 'CI',
    countryName: "Côte d'Ivoire",
    currencyCode: 'XOF',
  },
  {
    countryCode: 'CK',
    countryName: 'Cook Islands',
    currencyCode: 'NZD',
  },
  {
    countryCode: 'CL',
    countryName: 'Chile',
    currencyCode: 'CLP',
  },
  {
    countryCode: 'CM',
    countryName: 'Cameroon',
    currencyCode: 'XAF',
  },
  {
    countryCode: 'CN',
    countryName: 'China',
    currencyCode: 'CNY',
  },
  {
    countryCode: 'CO',
    countryName: 'Colombia',
    currencyCode: 'COP',
  },
  {
    countryCode: 'CR',
    countryName: 'Costa Rica',
    currencyCode: 'CRC',
  },
  {
    countryCode: 'CU',
    countryName: 'Cuba',
    currencyCode: 'CUP',
  },
  {
    countryCode: 'CV',
    countryName: 'Cape Verde',
    currencyCode: 'CVE',
  },
  {
    countryCode: 'CW',
    countryName: 'Curaçao',
    currencyCode: 'ANG',
  },
  {
    countryCode: 'CX',
    countryName: 'Christmas Island',
    currencyCode: 'AUD',
  },
  {
    countryCode: 'CY',
    countryName: 'Cyprus',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'CZ',
    countryName: 'Czech Republic',
    currencyCode: 'CZK',
  },
  {
    countryCode: 'DE',
    countryName: 'Germany',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'DJ',
    countryName: 'Djibouti',
    currencyCode: 'DJF',
  },
  {
    countryCode: 'DK',
    countryName: 'Denmark',
    currencyCode: 'DKK',
  },
  {
    countryCode: 'DM',
    countryName: 'Dominica',
    currencyCode: 'XCD',
  },
  {
    countryCode: 'DO',
    countryName: 'Dominican Republic',
    currencyCode: 'DOP',
  },
  {
    countryCode: 'DZ',
    countryName: 'Algeria',
    currencyCode: 'DZD',
  },
  {
    countryCode: 'EC',
    countryName: 'Ecuador',
    currencyCode: 'USD',
  },
  {
    countryCode: 'EE',
    countryName: 'Estonia',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'EG',
    countryName: 'Egypt',
    currencyCode: 'EGP',
  },
  {
    countryCode: 'EH',
    countryName: 'Western Sahara',
    currencyCode: 'MAD',
  },
  {
    countryCode: 'ER',
    countryName: 'Eritrea',
    currencyCode: 'ERN',
  },
  {
    countryCode: 'ES',
    countryName: 'Spain',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'ET',
    countryName: 'Ethiopia',
    currencyCode: 'ETB',
  },
  {
    countryCode: 'FI',
    countryName: 'Finland',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'FJ',
    countryName: 'Fiji',
    currencyCode: 'FJD',
  },
  {
    countryCode: 'FK',
    countryName: 'Falkland Islands',
    currencyCode: 'FKP',
  },
  {
    countryCode: 'FM',
    countryName: 'Micronesia',
    currencyCode: 'USD',
  },
  {
    countryCode: 'FO',
    countryName: 'Faroe Islands',
    currencyCode: 'DKK',
  },
  {
    countryCode: 'FR',
    countryName: 'France',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'GA',
    countryName: 'Gabon',
    currencyCode: 'XAF',
  },
  {
    countryCode: 'GB',
    countryName: 'United Kingdom',
    currencyCode: 'GBP',
  },
  {
    countryCode: 'GD',
    countryName: 'Grenada',
    currencyCode: 'XCD',
  },
  {
    countryCode: 'GE',
    countryName: 'Georgia',
    currencyCode: 'GEL',
  },
  {
    countryCode: 'GF',
    countryName: 'French Guiana',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'GG',
    countryName: 'Guernsey',
    currencyCode: 'GBP',
  },
  {
    countryCode: 'GH',
    countryName: 'Ghana',
    currencyCode: 'GHS',
  },
  {
    countryCode: 'GI',
    countryName: 'Gibraltar',
    currencyCode: 'GIP',
  },
  {
    countryCode: 'GL',
    countryName: 'Greenland',
    currencyCode: 'DKK',
  },
  {
    countryCode: 'GM',
    countryName: 'Gambia',
    currencyCode: 'GMD',
  },
  {
    countryCode: 'GN',
    countryName: 'Guinea',
    currencyCode: 'GNF',
  },
  {
    countryCode: 'GP',
    countryName: 'Guadeloupe',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'GQ',
    countryName: 'Equatorial Guinea',
    currencyCode: 'XAF',
  },
  {
    countryCode: 'GR',
    countryName: 'Greece',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'GS',
    countryName: 'South Georgia and the South Sandwich Islands',
    currencyCode: 'GBP',
  },
  {
    countryCode: 'GT',
    countryName: 'Guatemala',
    currencyCode: 'GTQ',
  },
  {
    countryCode: 'GU',
    countryName: 'Guam',
    currencyCode: 'USD',
  },
  {
    countryCode: 'GW',
    countryName: 'Guinea-Bissau',
    currencyCode: 'XOF',
  },
  {
    countryCode: 'GY',
    countryName: 'Guyana',
    currencyCode: 'GYD',
  },
  {
    countryCode: 'HK',
    countryName: 'Hong Kong',
    currencyCode: 'HKD',
  },
  {
    countryCode: 'HM',
    countryName: 'Heard Island and McDonald Islands',
    currencyCode: 'AUD',
  },
  {
    countryCode: 'HN',
    countryName: 'Honduras',
    currencyCode: 'HNL',
  },
  {
    countryCode: 'HR',
    countryName: 'Croatia',
    currencyCode: 'HRK',
  },
  {
    countryCode: 'HT',
    countryName: 'Haiti',
    currencyCode: 'HTG',
  },
  {
    countryCode: 'HU',
    countryName: 'Hungary',
    currencyCode: 'HUF',
  },
  {
    countryCode: 'ID',
    countryName: 'Indonesia',
    currencyCode: 'IDR',
  },
  {
    countryCode: 'IE',
    countryName: 'Ireland',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'IL',
    countryName: 'Israel',
    currencyCode: 'ILS',
  },
  {
    countryCode: 'IM',
    countryName: 'Isle of Man',
    currencyCode: 'GBP',
  },
  {
    countryCode: 'IN',
    countryName: 'India',
    currencyCode: 'INR',
  },
  {
    countryCode: 'IO',
    countryName: 'British Indian Ocean Territory',
    currencyCode: 'USD',
  },
  {
    countryCode: 'IQ',
    countryName: 'Iraq',
    currencyCode: 'IQD',
  },
  {
    countryCode: 'IR',
    countryName: 'Iran',
    currencyCode: 'IRR',
  },
  {
    countryCode: 'IS',
    countryName: 'Iceland',
    currencyCode: 'ISK',
  },
  {
    countryCode: 'IT',
    countryName: 'Italy',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'JE',
    countryName: 'Jersey',
    currencyCode: 'GBP',
  },
  {
    countryCode: 'JM',
    countryName: 'Jamaica',
    currencyCode: 'JMD',
  },
  {
    countryCode: 'JO',
    countryName: 'Jordan',
    currencyCode: 'JOD',
  },
  {
    countryCode: 'JP',
    countryName: 'Japan',
    currencyCode: 'JPY',
  },
  {
    countryCode: 'KE',
    countryName: 'Kenya',
    currencyCode: 'KES',
  },
  {
    countryCode: 'KG',
    countryName: 'Kyrgyzstan',
    currencyCode: 'KGS',
  },
  {
    countryCode: 'KH',
    countryName: 'Cambodia',
    currencyCode: 'KHR',
  },
  {
    countryCode: 'KI',
    countryName: 'Kiribati',
    currencyCode: 'AUD',
  },
  {
    countryCode: 'KM',
    countryName: 'Comoros',
    currencyCode: 'KMF',
  },
  {
    countryCode: 'KN',
    countryName: 'Saint Kitts and Nevis',
    currencyCode: 'XCD',
  },
  {
    countryCode: 'KP',
    countryName: 'North Korea',
    currencyCode: 'KPW',
  },
  {
    countryCode: 'KR',
    countryName: 'South Korea',
    currencyCode: 'KRW',
  },
  {
    countryCode: 'KW',
    countryName: 'Kuwait',
    currencyCode: 'KWD',
  },
  {
    countryCode: 'KY',
    countryName: 'Cayman Islands',
    currencyCode: 'KYD',
  },
  {
    countryCode: 'KZ',
    countryName: 'Kazakhstan',
    currencyCode: 'KZT',
  },
  {
    countryCode: 'LA',
    countryName: 'Laos',
    currencyCode: 'LAK',
  },
  {
    countryCode: 'LB',
    countryName: 'Lebanon',
    currencyCode: 'LBP',
  },
  {
    countryCode: 'LC',
    countryName: 'Saint Lucia',
    currencyCode: 'XCD',
  },
  {
    countryCode: 'LI',
    countryName: 'Liechtenstein',
    currencyCode: 'CHF',
  },
  {
    countryCode: 'LK',
    countryName: 'Sri Lanka',
    currencyCode: 'LKR',
  },
  {
    countryCode: 'LR',
    countryName: 'Liberia',
    currencyCode: 'LRD',
  },
  {
    countryCode: 'LS',
    countryName: 'Lesotho',
    currencyCode: 'LSL',
  },
  {
    countryCode: 'LT',
    countryName: 'Lithuania',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'LU',
    countryName: 'Luxembourg',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'LV',
    countryName: 'Latvia',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'LY',
    countryName: 'Libya',
    currencyCode: 'LYD',
  },
  {
    countryCode: 'MA',
    countryName: 'Morocco',
    currencyCode: 'MAD',
  },
  {
    countryCode: 'MC',
    countryName: 'Monaco',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'MD',
    countryName: 'Moldova',
    currencyCode: 'MDL',
  },
  {
    countryCode: 'ME',
    countryName: 'Montenegro',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'MF',
    countryName: 'Saint Martin',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'MG',
    countryName: 'Madagascar',
    currencyCode: 'MGA',
  },
  {
    countryCode: 'MH',
    countryName: 'Marshall Islands',
    currencyCode: 'USD',
  },
  {
    countryCode: 'MK',
    countryName: 'North Macedonia',
    currencyCode: 'MKD',
  },
  {
    countryCode: 'ML',
    countryName: 'Mali',
    currencyCode: 'XOF',
  },
  {
    countryCode: 'MM',
    countryName: 'Myanmar',
    currencyCode: 'MMK',
  },
  {
    countryCode: 'MN',
    countryName: 'Mongolia',
    currencyCode: 'MNT',
  },
  {
    countryCode: 'MO',
    countryName: 'Macao',
    currencyCode: 'MOP',
  },
  {
    countryCode: 'MP',
    countryName: 'Northern Mariana Islands',
    currencyCode: 'USD',
  },
  {
    countryCode: 'MQ',
    countryName: 'Martinique',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'MR',
    countryName: 'Mauritania',
    currencyCode: 'MRO',
  },
  {
    countryCode: 'MS',
    countryName: 'Montserrat',
    currencyCode: 'XCD',
  },
  {
    countryCode: 'MT',
    countryName: 'Malta',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'MU',
    countryName: 'Mauritius',
    currencyCode: 'MUR',
  },
  {
    countryCode: 'MV',
    countryName: 'Maldives',
    currencyCode: 'MVR',
  },
  {
    countryCode: 'MW',
    countryName: 'Malawi',
    currencyCode: 'MWK',
  },
  {
    countryCode: 'MX',
    countryName: 'Mexico',
    currencyCode: 'MXN',
  },
  {
    countryCode: 'MY',
    countryName: 'Malaysia',
    currencyCode: 'MYR',
  },
  {
    countryCode: 'MZ',
    countryName: 'Mozambique',
    currencyCode: 'MZN',
  },
  {
    countryCode: 'NA',
    countryName: 'Namibia',
    currencyCode: 'NAD',
  },
  {
    countryCode: 'NC',
    countryName: 'New Caledonia',
    currencyCode: 'XPF',
  },
  {
    countryCode: 'NE',
    countryName: 'Niger',
    currencyCode: 'XOF',
  },
  {
    countryCode: 'NF',
    countryName: 'Norfolk Island',
    currencyCode: 'AUD',
  },
  {
    countryCode: 'NG',
    countryName: 'Nigeria',
    currencyCode: 'NGN',
  },
  {
    countryCode: 'NI',
    countryName: 'Nicaragua',
    currencyCode: 'NIO',
  },
  {
    countryCode: 'NL',
    countryName: 'Netherlands',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'NO',
    countryName: 'Norway',
    currencyCode: 'NOK',
  },
  {
    countryCode: 'NP',
    countryName: 'Nepal',
    currencyCode: 'NPR',
  },
  {
    countryCode: 'NR',
    countryName: 'Nauru',
    currencyCode: 'AUD',
  },
  {
    countryCode: 'NU',
    countryName: 'Niue',
    currencyCode: 'NZD',
  },
  {
    countryCode: 'NZ',
    countryName: 'New Zealand',
    currencyCode: 'NZD',
  },
  {
    countryCode: 'OM',
    countryName: 'Oman',
    currencyCode: 'OMR',
  },
  {
    countryCode: 'PA',
    countryName: 'Panama',
    currencyCode: 'PAB',
  },
  {
    countryCode: 'PE',
    countryName: 'Peru',
    currencyCode: 'PEN',
  },
  {
    countryCode: 'PF',
    countryName: 'French Polynesia',
    currencyCode: 'XPF',
  },
  {
    countryCode: 'PG',
    countryName: 'Papua New Guinea',
    currencyCode: 'PGK',
  },
  {
    countryCode: 'PH',
    countryName: 'Philippines',
    currencyCode: 'PHP',
  },
  {
    countryCode: 'PK',
    countryName: 'Pakistan',
    currencyCode: 'PKR',
  },
  {
    countryCode: 'PL',
    countryName: 'Poland',
    currencyCode: 'PLN',
  },
  {
    countryCode: 'PM',
    countryName: 'Saint Pierre and Miquelon',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'PN',
    countryName: 'Pitcairn Islands',
    currencyCode: 'NZD',
  },
  {
    countryCode: 'PR',
    countryName: 'Puerto Rico',
    currencyCode: 'USD',
  },
  {
    countryCode: 'PS',
    countryName: 'Palestine',
    currencyCode: 'ILS',
  },
  {
    countryCode: 'PT',
    countryName: 'Portugal',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'PW',
    countryName: 'Palau',
    currencyCode: 'USD',
  },
  {
    countryCode: 'PY',
    countryName: 'Paraguay',
    currencyCode: 'PYG',
  },
  {
    countryCode: 'QA',
    countryName: 'Qatar',
    currencyCode: 'QAR',
  },
  {
    countryCode: 'RE',
    countryName: 'Réunion',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'RO',
    countryName: 'Romania',
    currencyCode: 'RON',
  },
  {
    countryCode: 'RS',
    countryName: 'Serbia',
    currencyCode: 'RSD',
  },
  {
    countryCode: 'RU',
    countryName: 'Russia',
    currencyCode: 'RUB',
  },
  {
    countryCode: 'RW',
    countryName: 'Rwanda',
    currencyCode: 'RWF',
  },
  {
    countryCode: 'SA',
    countryName: 'Saudi Arabia',
    currencyCode: 'SAR',
  },
  {
    countryCode: 'SB',
    countryName: 'Solomon Islands',
    currencyCode: 'SBD',
  },
  {
    countryCode: 'SC',
    countryName: 'Seychelles',
    currencyCode: 'SCR',
  },
  {
    countryCode: 'SD',
    countryName: 'Sudan',
    currencyCode: 'SDG',
  },
  {
    countryCode: 'SE',
    countryName: 'Sweden',
    currencyCode: 'SEK',
  },
  {
    countryCode: 'SG',
    countryName: 'Singapore',
    currencyCode: 'SGD',
  },
  {
    countryCode: 'SH',
    countryName: 'Saint Helena',
    currencyCode: 'SHP',
  },
  {
    countryCode: 'SI',
    countryName: 'Slovenia',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'SJ',
    countryName: 'Svalbard and Jan Mayen',
    currencyCode: 'NOK',
  },
  {
    countryCode: 'SK',
    countryName: 'Slovakia',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'SL',
    countryName: 'Sierra Leone',
    currencyCode: 'SLL',
  },
  {
    countryCode: 'SM',
    countryName: 'San Marino',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'SN',
    countryName: 'Senegal',
    currencyCode: 'XOF',
  },
  {
    countryCode: 'SO',
    countryName: 'Somalia',
    currencyCode: 'SOS',
  },
  {
    countryCode: 'SR',
    countryName: 'Suriname',
    currencyCode: 'SRD',
  },
  {
    countryCode: 'SS',
    countryName: 'South Sudan',
    currencyCode: 'SSP',
  },
  {
    countryCode: 'ST',
    countryName: 'São Tomé and Príncipe',
    currencyCode: 'STD',
  },
  {
    countryCode: 'SV',
    countryName: 'El Salvador',
    currencyCode: 'USD',
  },
  {
    countryCode: 'SX',
    countryName: 'Sint Maarten',
    currencyCode: 'ANG',
  },
  {
    countryCode: 'SY',
    countryName: 'Syria',
    currencyCode: 'SYP',
  },
  {
    countryCode: 'SZ',
    countryName: 'Eswatini',
    currencyCode: 'SZL',
  },
  {
    countryCode: 'TC',
    countryName: 'Turks and Caicos Islands',
    currencyCode: 'USD',
  },
  {
    countryCode: 'TD',
    countryName: 'Chad',
    currencyCode: 'XAF',
  },
  {
    countryCode: 'TF',
    countryName: 'French Southern Territories',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'TG',
    countryName: 'Togo',
    currencyCode: 'XOF',
  },
  {
    countryCode: 'TH',
    countryName: 'Thailand',
    currencyCode: 'THB',
  },
  {
    countryCode: 'TJ',
    countryName: 'Tajikistan',
    currencyCode: 'TJS',
  },
  {
    countryCode: 'TK',
    countryName: 'Tokelau',
    currencyCode: 'NZD',
  },
  {
    countryCode: 'TL',
    countryName: 'Timor-Leste',
    currencyCode: 'USD',
  },
  {
    countryCode: 'TM',
    countryName: 'Turkmenistan',
    currencyCode: 'TMT',
  },
  {
    countryCode: 'TN',
    countryName: 'Tunisia',
    currencyCode: 'TND',
  },
  {
    countryCode: 'TO',
    countryName: 'Tonga',
    currencyCode: 'TOP',
  },
  {
    countryCode: 'TR',
    countryName: 'Turkey',
    currencyCode: 'TRY',
  },
  {
    countryCode: 'TT',
    countryName: 'Trinidad and Tobago',
    currencyCode: 'TTD',
  },
  {
    countryCode: 'TV',
    countryName: 'Tuvalu',
    currencyCode: 'AUD',
  },
  {
    countryCode: 'TW',
    countryName: 'Taiwan',
    currencyCode: 'TWD',
  },
  {
    countryCode: 'TZ',
    countryName: 'Tanzania',
    currencyCode: 'TZS',
  },
  {
    countryCode: 'UA',
    countryName: 'Ukraine',
    currencyCode: 'UAH',
  },
  {
    countryCode: 'UG',
    countryName: 'Uganda',
    currencyCode: 'UGX',
  },
  {
    countryCode: 'UM',
    countryName: 'United States Minor Outlying Islands',
    currencyCode: 'USD',
  },
  {
    countryCode: 'US',
    countryName: 'United States',
    currencyCode: 'USD',
  },
  {
    countryCode: 'UY',
    countryName: 'Uruguay',
    currencyCode: 'UYU',
  },
  {
    countryCode: 'UZ',
    countryName: 'Uzbekistan',
    currencyCode: 'UZS',
  },
  {
    countryCode: 'VA',
    countryName: 'Vatican City',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'VC',
    countryName: 'Saint Vincent and the Grenadines',
    currencyCode: 'XCD',
  },
  {
    countryCode: 'VE',
    countryName: 'Venezuela',
    currencyCode: 'VEF',
  },
  {
    countryCode: 'VG',
    countryName: 'British Virgin Islands',
    currencyCode: 'USD',
  },
  {
    countryCode: 'VI',
    countryName: 'United States Virgin Islands',
    currencyCode: 'USD',
  },
  {
    countryCode: 'VN',
    countryName: 'Vietnam',
    currencyCode: 'VND',
  },
  {
    countryCode: 'VU',
    countryName: 'Vanuatu',
    currencyCode: 'VUV',
  },
  {
    countryCode: 'WF',
    countryName: 'Wallis and Futuna',
    currencyCode: 'XPF',
  },
  {
    countryCode: 'WS',
    countryName: 'Samoa',
    currencyCode: 'WST',
  },
  {
    countryCode: 'XK',
    countryName: 'Kosovo',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'YE',
    countryName: 'Yemen',
    currencyCode: 'YER',
  },
  {
    countryCode: 'YT',
    countryName: 'Mayotte',
    currencyCode: 'EUR',
  },
  {
    countryCode: 'ZA',
    countryName: 'South Africa',
    currencyCode: 'ZAR',
  },
  {
    countryCode: 'ZM',
    countryName: 'Zambia',
    currencyCode: 'ZMW',
  },
  {
    countryCode: 'ZW',
    countryName: 'Zimbabwe',
    currencyCode: 'ZWL',
  },
];

export const defaultBorderProps = {
  border: {
    deviceType: 'desktop',
    borderBottomLeft: {
      desktop: '6',
      tablet: '6',
      mobile: '6',
    },
    borderBottomRight: {
      desktop: '6',
      tablet: '6',
      mobile: '6',
    },
    borderTopLeft: {
      desktop: '6',
      tablet: '6',
      mobile: '6',
    },
    borderTopRight: {
      desktop: '6',
      tablet: '6',
      mobile: '6',
    },
    borderTopWidth: {
      desktop: 1,
      tablet: 1,
      mobile: 1,
    },
    borderRightWidth: {
      desktop: 1,
      tablet: 1,
      mobile: 1,
    },
    borderBottomWidth: {
      desktop: 1,
      tablet: 1,
      mobile: 1,
    },
    borderLeftWidth: {
      desktop: 1,
      tablet: 1,
      mobile: 1,
    },
    borderWidth: {
      desktop: 1,
      tablet: 1,
      mobile: 1,
    },
    borderStyle: {
      desktop: 'border-solid',
      tablet: 'border-solid',
      mobile: 'border-solid',
    },
    borderColor: {
      desktop: '#dadde2',
      tablet: '#dadde2',
      mobile: '#dadde2',
    },
  },
};
